import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SidebarRightComponent } from './sidebar-right.component';

@NgModule({
    imports: [CommonModule],
    exports: [SidebarRightComponent],
    declarations: [SidebarRightComponent]
})
export class SidebarRightModule {}
